import actions from './actions';
import mutations from './mutations';
import { State } from './types';

export const getInitialState = () => ({
  alertCenterChecks: {},
  formattedEntityMappedAlerts: {}
});

const state: State = getInitialState();

export default {
  state,
  mutations,
  actions,
  namespaced: true
};
